import script from "./ConnectionDeleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectionDeleteModal.vue?vue&type=script&setup=true&lang=js"

import "./ConnectionDeleteModal.vue?vue&type=style&index=0&id=73e2c416&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e2c416"]])

export default __exports__